'use strict'
// Template version: 1.3.1
// see http://vuejs-templates.github.io/webpack for documentation.

const path = require('path');

var indexPage = "vevox-dashboard";
if (typeof process.env.INDEX_PAGE != "undefined" && process.env.INDEX_PAGE != "") {
  indexPage = process.env.INDEX_PAGE;
}
console.log('Using index page: ' + indexPage);

var myHost = "localhost";
if (typeof process.env.HOST != "undefined" && process.env.HOST != "") {
  myHost = process.env.HOST;
}
console.log('Using dev host: ' + myHost);

function getFavicon() {
  if (indexPage == "single-login-page") return "static/images/favicon.png";
  if (indexPage == "signup") return "static/images/favicon.png";
  if (indexPage == "vevox-participant-app") return "static/images/favicon.png";
  if (indexPage == "agm-dashboard") return "static/images/agm/favicon.png";
  if (indexPage == "agm-participant-app") return "static/images/agm/favicon.ico";
  if (indexPage == "loadtest-dashboard") return "static/images/loadtest/favicon.png";
  if (indexPage == "ventureport-dashboard") return "static/images/ventureport/ventureport-favicon.ico";
  return 'static/images/favicon.png';
}

function getFavicon16() {
  if (indexPage == "single-login-page") return "static/images/vevox/favicon-16x16.png";
  if (indexPage == "signup") return "static/images/vevox/favicon-16x16.png";
  if (indexPage == "vevox-participant-app") return "static/images/vevox/favicon-16x16.png";
  if (indexPage == "agm-dashboard") return "static/images/agm/favicon.png";
  if (indexPage == "agm-participant-app") return "static/images/agm/favicon.ico";
  if (indexPage == "loadtest-dashboard") return "static/images/loadtest/favicon.png";
  if (indexPage == "ventureport-dashboard") return "static/images/ventureport/ventureport-favicon.ico";
  return "static/images/vevox/favicon-16x16.png";
}

function getFavicon32() {
  if (indexPage == "single-login-page") return "static/images/vevox/favicon-32x32.png";
  if (indexPage == "signup") return "static/images/vevox/favicon-32x32.png";
  if (indexPage == "vevox-participant-app") return "static/images/vevox/favicon-32x32.png";
  if (indexPage == "agm-dashboard") return "static/images/agm/favicon.png";
  if (indexPage == "agm-participant-app") return "static/images/agm/favicon.ico";
  if (indexPage == "loadtest-dashboard") return "static/images/loadtest/favicon.png";
  if (indexPage == "ventureport-dashboard") return "static/images/ventureport/ventureport-favicon.ico";
  return "static/images/vevox/favicon-32x32.png";
}

function vevoxHeadExtras() {
  return ''
    + '<link rel="manifest" href="/static/images/vevox/site.webmanifest">'
    + '<link rel="mask-icon" href="/static/images/vevox/safari-pinned-tab.svg" color="#5bbad5">'
    + '<meta name="msapplication-TileColor" content="#da532c">'
    + '<meta name="msapplication-config" content="/static/images/vevox/browserconfig.xml">'
    + '<meta name="theme-color" content="#ffffff"></meta>';
}

function getHeadExtras() {
  if (indexPage == "single-login-page") return vevoxHeadExtras();
  if (indexPage == "signup") return vevoxHeadExtras();
  if (indexPage == "vevox-participant-app") return vevoxHeadExtras();
  if (indexPage == "agm-dashboard") return "";
  if (indexPage == "agm-participant-app") return "";
  if (indexPage == "loadtest-dashboard") return "";
  if (indexPage == "ventureport-dashboard") return "";
  return vevoxHeadExtras();
}

function getAppleTouchIcon() {
  if (indexPage == "single-login-page") return "static/images/vevox/apple-touch-icon.png";
  if (indexPage == "signup") return "static/images/vevox/apple-touch-icon.png";
  if (indexPage == "vevox-participant-app") return "static/images/vevox/apple-touch-icon.png";
  if (indexPage == "agm-dashboard") return "static/images/agm/favicon.png";
  if (indexPage == "agm-participant-app") return "static/images/agm/favicon.ico";
  if (indexPage == "loadtest-dashboard") return "static/images/loadtest/favicon.png";
  if (indexPage == "ventureport-dashboard") return "static/images/ventureport/ventureport-favicon.ico";
  return "static/images/vevox/apple-touch-icon.png";
}

function getFaviconType() {
  if (indexPage == "single-login-page") return "image/png";
  if (indexPage == "signup") return "image/png";
  if (indexPage == "vevox-participant-app") return "image/png";
  if (indexPage == "agm-dashboard") return "image/png";
  if (indexPage == "agm-participant-app") return "image/x-icon";
  if (indexPage == "ventureport-dashboard") return "image/x-icon";
  return 'image/png';
}

function getTitle() {
  if (indexPage == "single-login-page") return "Vevox - Login";
  if (indexPage == "signup") return "Vevox - Sign up";
  if (indexPage == "vevox-participant-app") return "Vevox";
  if (indexPage == "agm-dashboard") return "Lumi";
  if (indexPage == "agm-participant-app") return "Lumi";
  if (indexPage == "loadtest-dashboard") return "Loadtest Dashboard";
  if (indexPage == "ventureport-dashboard") return "VenturePort";
  return '';
}

function getDescription() {
  if (indexPage == "single-login-page") return "Log in to your Vevox account";
  if (indexPage == "signup") return "Sign up for a FREE Vevox account";
  if (indexPage == "vevox-participant-app") return "Vevox is a real-time audience engagement app for the workplace and classes.";
  if (indexPage == "agm-dashboard") return "Lumi";
  if (indexPage == "agm-participant-app") return "Lumi";
  return '';
}

function getAllowTranslate() {
  if (indexPage == "agm-participant-app") return "no"; //disable translation of AGM participant app
  return '';
}

var to_export = {
  getPagesToBuild: function() {
    var pages = [
      'microsoftlogin.html',
      'resetpassword',
      'accesstoken.html',
      'sidebar.html',
      'lti.html'
    ];
    if (process.env.PAGES_TO_BUILD) {
      pages = process.env.PAGES_TO_BUILD.split(",");
    }
    //ventureport does not have a sidebar
    if (indexPage === 'ventureport-dashboard') {
      pages = pages.filter(page => page !== 'sidebar.html');
    }
    return pages;
  },
  stripFileType: function(page) {
    var index = -1;
    if ((index = page.indexOf('.html')) != -1) {
      page = page.substring(0, index);
    }
    return page;
  },
    //remove current page from pages to create exclude list
  generateExcludeList: function(page) {
    page = this.stripFileType(page);
    var pages = this.getPagesToBuild();
    var excludeChunks = ["index"];
    for (var i=0; i<pages.length; i++) {
      excludeChunks.push(this.stripFileType(pages[i]));
    }
    excludeChunks.splice(excludeChunks.indexOf(page), 1);
    return excludeChunks;
  },

  dev: {
    // Template for index.html
    index: path.resolve(__dirname, '../dist/' + indexPage +'/index.html'),

    // Paths
    assetsSubDirectory: 'static',
    assetsPublicPath: '/',
    proxyTable: {},

    httpapiEndpoint: (process.env.HTTPAPI_ENDPOINT == null || process.env.HTTPAPI_ENDPOINT == 'undefined') ? 'ws://' + myHost + ':8888/api' : process.env.HTTPAPI_ENDPOINT,
    playDashboardDomain: (process.env.PLAY_DASHBOARD_DOMAIN == null || process.env.PLAY_DASHBOARD_DOMAIN == 'undefined') ? myHost : process.env.PLAY_DASHBOARD_DOMAIN,
    webClientDomain: 'localhost',
    audienceDisplayUrl: 'http://' + myHost + ':8085',
    publicResourcesUrl: 'https://publicresources.vevox.com/',
    pptLoginUrl: (process.env.PPT_LOGIN_URL == null || process.env.PPT_LOGIN_URL == 'undefined') ? 'https://localhost:3000/login.html' : process.env.PPT_LOGIN_URL,
    teamsLoginUrl: (process.env.TEAMS_LOGIN_URL == null || process.env.TEAMS_LOGIN_URL == 'undefined') ? 'https://localhost:3000/login.html' : process.env.TEAMS_LOGIN_URL,
    indexPage: indexPage,
    indexTitle: getTitle(),
    indexDescription: getDescription(),
    allowTranslate: getAllowTranslate(),
    favicon: getFavicon(),
    favicon16: getFavicon16(),
    favicon32: getFavicon32(),
    appleTouchIcon: getAppleTouchIcon(),
    headExtras: getHeadExtras(),
    faviconType: getFaviconType(),
    isProductionDomain: process.env.IS_PRODUCTION_DOMAIN,
    displayWatermark: process.env.DISPLAY_WATERMARK,
    buildNumber:  process.env.BUILD_NUMBER,
    gerritBranch:  process.env.GERRIT_BRANCH,
    singleSession: true,
    appId: "b04cda41-22ea-40a5-a5e4-ce951bd12067",
    projectType: 'anonymous',
    allowedRedirectUrls: ["", myHost],
    firstStepSignupURL: "http://" + myHost + ":8083/#/createAccount/",
    secondStepSignupURL: "http://" + myHost + ":8083/#/setupAccount/",
    singleLoginPageDomain: myHost + ':8086',
    singleLoginPageAddress: 'http://' + myHost + ':8086/',
    useDynamicGateways: process.env.USE_DYNAMIC_GATEWAYS,
    appcuesKey: process.env.APPCUES_KEY,
    junesoKey: process.env.JUNESO_KEY,


    // Various Dev Server settings
    host: myHost,
    port: indexPage === 'agm-participant-app' ? 8102 : 8080, // can be overwritten by process.env.PORT, if port is in use, a free one will be determined
    autoOpenBrowser: false,
    errorOverlay: true,
    notifyOnErrors: true,
    poll: false, // https://webpack.js.org/configuration/dev-server/#devserver-watchoptions-


    /**
     * Source Maps
     */

    // https://webpack.js.org/configuration/devtool/#development
    devtool: 'cheap-module-eval-source-map',

    // If you have problems debugging vue-files in devtools,
    // set this to false - it *may* help
    // https://vue-loader.vuejs.org/en/options.html#cachebusting
    cacheBusting: true,

    cssSourceMap: true,

    transpileDependencies: ['vuetify'],
  },

  build: {
    // Template for index.html
    index: path.resolve(__dirname, '../dist/' + indexPage +'/index.html'),

    // Paths
    assetsRoot: path.resolve(__dirname, '../dist/' + indexPage),
    assetsSubDirectory: 'static',
    assetsPublicPath: './',

    httpapiEndpoint: process.env.HTTPAPI_ENDPOINT,
    playDashboardDomain: process.env.PLAY_DASHBOARD_DOMAIN,
    webClientDomain: process.env.WEB_CLIENT_DOMAIN,
    audienceDisplayUrl: process.env.AUDIENCE_DISPLAY_URL,
    reactorDashboardDomain: process.env.REACTOR_DASHBOARD_DOMAIN,
    pptLoginUrl: process.env.PPT_LOGIN_URL,
    teamsLoginUrl: process.env.TEAMS_LOGIN_URL,
    publicResourcesUrl: 'https://publicresources.vevox.com/',
    indexPage: indexPage,
    indexTitle: getTitle(),
    indexDescription: getDescription(),
    allowTranslate: getAllowTranslate(),
    favicon: getFavicon(),
    favicon16: getFavicon16(),
    favicon32: getFavicon32(),
    appleTouchIcon: getAppleTouchIcon(),
    headExtras: getHeadExtras(),
    faviconType: getFaviconType(),
    isProductionDomain: process.env.IS_PRODUCTION_DOMAIN,
    displayWatermark: process.env.DISPLAY_WATERMARK,
    buildNumber:  process.env.BUILD_NUMBER,
    gerritBranch:  process.env.GERRIT_BRANCH,
    singleSession: true,
    appId: "b04cda41-22ea-40a5-a5e4-ce951bd12067",
    projectType: 'anonymous',
    allowedRedirectUrls: [process.env.SINGLE_LOGIN_PAGE_DOMAIN, process.env.WEB_CLIENT_DOMAIN, process.env.SIGNUP_PAGE_DOMAIN],
    singleLoginPageDomain: process.env.SINGLE_LOGIN_PAGE_DOMAIN,
    singleLoginPageAddress: 'https://' + process.env.SINGLE_LOGIN_PAGE_DOMAIN + '/',
    firstStepSignupURL: process.env.FIRST_STEP_SIGNUP_URL,
    secondStepSignupURL: process.env.SECOND_STEP_SIGNUP_URL,
    useDynamicGateways: process.env.USE_DYNAMIC_GATEWAYS,
    appcuesKey: process.env.APPCUES_KEY,
    junesoKey: process.env.JUNESO_KEY,


    /**
     * Source Maps
     */

    productionSourceMap: true,
    // https://webpack.js.org/configuration/devtool/#production
    devtool: '#source-map',

    // Gzip off by default as many popular static hosts such as
    // Surge or Netlify already gzip all static assets for you.
    // Before setting to `true`, make sure to:
    // npm install --save-dev compression-webpack-plugin
    productionGzip: false,
    productionGzipExtensions: ['js', 'css'],

    // Run the build command with an extra argument to
    // View the bundle analyzer report after build finishes:
    // `npm run build --report`
    // Set to `true` or `false` to always turn it on or off
    bundleAnalyzerReport: process.env.npm_config_report
  }

}

var pages = to_export.getPagesToBuild();
for (var i=0; i<pages.length; i++) {
  var page = pages[i];
  var page_no_type = to_export.stripFileType(pages[i]);
  to_export.dev[page_no_type] = path.resolve(__dirname, '../dist/' + indexPage + '/' + page);
  to_export.build[page_no_type] = path.resolve(__dirname, '../dist/' + indexPage + '/' + page);
}

module.exports = to_export;




//////////////////
// WEBPACK FOOTER
// ./config/index.js
// module id = FhoZ
// module chunks = 1 2 3 4 5 6